"use strict";

import 'bootstrap/js/dist/tab';

$(function() {
    if(window.location.hash == '#addreview'){
        $('#product-reviews-tab').tab('show');
    }

    // Style widths of review elements
    $('.catalogue-review-summary__score').each(function(i, el){
        var $el = $(el);
        $el.css('width', $el.data('percentage') + '%');
    });


    $('.catalogue-reviews-rating .catalogue-reviews-stars').on('click', '.catalogue-reviews-star', function(e) {
        var $el = $(this),
            target = $(e.delegateTarget).data('target');
        $el.addClass('active');
        $el.prevAll().addClass('active');
        $el.nextAll().removeClass('active');
        // Set the value on the hidden input
        $(target).val($el.data('value'));
    });
});
